import { Card, Heading, Stack } from '@etg/wings';
import { OrderState, type OrderState as OrderStateType } from '@eti/schema-types';
import { useAuth } from '@eti/authentication';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import RouteInfoWithSymbols from '../../common/RouteInfoWithSymbols';
import { getOriginDestinationPerBound } from '../../../utils';
import OrderNumber from './OrderNumber';
import OrderStateInfo from './OrderStateInfo';

const Header = () => {
  const { bounds, journeyType, orderState } = useOrderDetails();
  const { user } = useAuth();

  const shouldShowOrderStateInfo =
    orderState === OrderState.Canceled || orderState === OrderState.Changed;

  return (
    <Card>
      <Stack align="start" spacing={8}>
        {shouldShowOrderStateInfo && (
          <OrderStateInfo
            orderState={
              orderState as Extract<
                OrderStateType,
                typeof OrderState.Canceled | typeof OrderState.Changed
              >
            }
          />
        )}
        <Heading level={2}>
          <RouteInfoWithSymbols
            bounds={getOriginDestinationPerBound(bounds)}
            data-testid={`order-${user?.sessionOrderNumber}`}
            journeyType={journeyType}
          />
        </Heading>
        <OrderNumber />
      </Stack>
    </Card>
  );
};

export default Header;
